import UserService from '../services/user.service';
// import UtilService from '../services/util'
import StudentService from '../services/student.service';

export const users = {
  namespaced: true,
  state: {
    users: [],
    teamLeaders: [],
    isManager: false,
  },
  actions: {
    getAllUsers({ commit }, id) {
      return UserService.findAllUsers().then(
        (messages) => {
          commit('messageSuccess', {
            data: messages.data,
            userId: id,
          });
          return Promise.resolve();
        },
        (error) => {
          commit('messageFailure');
          return Promise.reject(error);
        }
      );
    },

    getAllTeamLeaders({ commit }) {
      return StudentService.getTeamLeaders(null).then(
        (messages) => {
          commit('setTeamLeaders', messages.data);
          return Promise.resolve();
        },
        (error) => {
          commit('messageFailure');
          return Promise.reject(error);
        }
      );
    },
  },

  mutations: {
    messageSuccess(state, response) {
      state.users = response.data.map((user) => {
        return {
          ...user,
          userRole: user.user_roles.length ? user.user_roles[0].roleId : null,
        };
      });
      state.isManager = response.data
        .filter((user) => user.id === response.userId)
        .map((user) => user.team_users.map((teamUser) => teamUser.isManager))[0]
        .includes(true);
    },

    setTeamLeaders(state, response) {
      state.teamLeaders = response;
    },
  },
};
